import {useEffect} from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider} from '@mui/material/styles';

import {getAnalytics, logEvent} from "firebase/analytics";

import ContactUs from "../components/ContactUs";
import MenuButton from "../components/MenuButton";
import UpcomingEvents from "../components/UpcomingEvents";
import Welcome from "../components/Welcome";
import Divider from "../../../components/common/Divider";
import ImageSlider from "../components/ImageSlider";
import MailingList from "../components/MailingList";

import {dizengoffMommiesTheme} from "../../../theme/theme";

function DizengoffMommies() {
    useEffect(() => {
        logEvent(getAnalytics(), 'dizengoff_mommies');
    }, []);

    return (
        <ThemeProvider theme={dizengoffMommiesTheme}>
            <CssBaseline/>
            <Box
                display={"flex"}
                flexDirection={"column"}
                sx={{
                    width: "100%",
                    maxWidth: "100vw", // Prevents the Box from exceeding the viewport width
                    overflowX: "hidden",
                }}
            >
                <MenuButton />
                <Welcome/>
                {/*<MailingList />*/}
                <UpcomingEvents/>
                <ImageSlider />
                <Divider/>
                <ContactUs/>
            </Box>
        </ThemeProvider>
    );
}

export default DizengoffMommies;
